export default "__VITE_ASSET__59a0fabf__"